import { adminConstants } from '../constant/admin-constant';

const initialState = {
	shippingOptions:[]
};

export function shippingOptionReducer(state = initialState, action){
	// console.log('type', action.type);
	switch(action.type) {
		case adminConstants.GET_SHIPPING_OPTION_SUCCESS:
			return {
                ...state,
                shippingOptions: action.payload
             };
		case adminConstants.STORE_SHIPPING_OPTION_SUCCESS:
            return {
                ...state,
                shippingOptions: [
                    ...state.shippingOptions,
                    action.payload.result.data
                ]
            };
        case adminConstants.DELETE_SHIPPING_OPTION_SUCCESS:
        	return {
        		...state,
        		shippingOptions: [
        			...state.shippingOptions.filter(item => item.id !== action.payload)
        		]
        	};
		default:
			return {...state};
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/ShippingOptionReducer.jsx